import React, { useState, useEffect } from 'react';
import './PopupNewsletter.css';

const PopupNewsletter: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const newsletterClosed = localStorage.getItem('newsletterClosed');
    if (!newsletterClosed) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem('newsletterClosed', 'true');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      alert(`Cảm ơn bạn đã đăng ký với email: ${email}`);
      setEmail('');
      handleClose();
    }
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-newsletter active" onClick={handleBackdropClick}>
      <div className="popup-content">
        <button className="close-popup" onClick={handleClose}>&times;</button>
        <h3>Giảm 10%</h3>
        <h4>Nhận thông tin về ưu đãi mới nhất</h4>
        <p>Đăng ký để nhận thông báo đầu tiên về cập nhật và ưu đãi mới nhất!</p>
        <form className="popup-form" onSubmit={handleSubmit}>
          <input 
            type="email" 
            placeholder="Nhập email của bạn"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Đăng ký</button>
        </form>
      </div>
    </div>
  );
};

export default PopupNewsletter;

